import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-fcsc-admin-section',
  templateUrl: './fcsc-admin-section.component.html',
  styleUrls: ['./fcsc-admin-section.component.scss'],
})
export class FcscAdminSectionComponent {
  constructor() {}
}
